"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { cn } from "@repo/design-system/utils/cn";
import { Mail } from "lucide-react";
import { ApplyButton } from "~/components/ui/apply-button-eon";
import { env } from "~/setup/env";
import type { JobadComponentProps } from "~/types/job";
export default function ContactEonUk(t0) {
  const $ = _c(4);
  const {
    job
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-8 flex w-full font-medium text-4xl lg:text-5xl"><h2 className="lg:w-96">Any questions?</h2></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col">{t1}<div className="space-y-4 pb-6"><p>If you have any questions about the role or the recruitment process, feel free to reach out by email - I'll be happy to help and will get back to you as soon as possible.</p><p>Please note: we do not accept CVs via email. All applications must be submitted through our online application system.</p><p>If this role sounds like the right fit for you, click 'Apply Now' to get started and take the next step in your career with us.</p></div></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== job) {
    t3 = <section className="flex w-full flex-col items-center justify-center bg-primary px-6 text-lg text-white md:px-10 print:hidden" id="contact"><div className="w-full max-w-screen-xl py-10 md:py-20"><div className="grid gap-3 lg:grid-cols-2">{t2}<div className="flex justify-center md:justify-end"><ContactImageEonUk job={job} /></div></div></div></section>;
    $[2] = job;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export function ContactImageEonUk(t0) {
  const $ = _c(20);
  const {
    job,
    sticky
  } = t0;
  if (!job.data.recruiterData) {
    return null;
  }
  const recruiterData = job.data.recruiterData;
  const imageSrc = `${env.NEXT_PUBLIC_ASSET_URL}images/recruiter/subclients/uk/${recruiterData.recruiter_image}`;
  const t1 = sticky && "max-h-[220px] object-contain";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("w-full bg-white object-cover pt-4", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== imageSrc || $[3] !== t2) {
    t3 = <CustomImage alt="Recruiter" className={t2} height={250} src={imageSrc} width={300} />;
    $[2] = imageSrc;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== recruiterData.recruiter_mail) {
    t4 = recruiterData.recruiter_mail && <a className="flex gap-x-2 font-medium hover:underline" href={`mailto:${recruiterData.recruiter_mail}`}><div className="w-8"><Mail className="size-6" /></div><p dangerouslySetInnerHTML={{
        __html: recruiterData.recruiter_mail.replaceAll("@", "&shy;@")
      }} data-source="job" /></a>;
    $[5] = recruiterData.recruiter_mail;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== job) {
    t5 = job.data.applicationUrl && job.data.applicationUrl.length > 2 && <ApplyButton className="!rounded-[8px] !px-4 mr-auto w-fit py-1 font-medium text-base md:py-2 lg:px-8" job={job}>Apply Now</ApplyButton>;
    $[7] = job;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== job) {
    t6 = job.data.applicationUrlDirect && <ApplyButton className="!rounded-[8px] !px-4 mr-auto w-fit py-1 font-medium text-base md:py-2 lg:px-8" direct={true} job={job} />;
    $[9] = job;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="mt-4 flex flex-col gap-2">{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t7) {
    t8 = <div className="flex w-full flex-col gap-2 bg-white px-5 pt-2 pb-5 text-primary lg:px-6 lg:pt-4">{t4}{t7}</div>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t3 || $[18] !== t8) {
    t9 = <div className="flex w-72 flex-col overflow-hidden bg-white">{t3}{t8}</div>;
    $[17] = t3;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}